import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

/**
 * Who took the call, and whether they are a person.
 *
 * The AI chip is the point: everywhere an agent appears — the queue, the
 * roster, a transcript — a reader should be able to tell in one glance which
 * work a person did and which the product did.
 */
export default function AgentName({
  person,
  subtitle,
}: {
  /** Anyone with a name who is either a person or an AI agent. */
  person: { name: string; kind: 'ai' | 'human' };
  subtitle?: string;
}) {
  return (
    <Stack direction="row" alignItems="center" spacing={0.75} sx={{ minWidth: 0 }}>
      <Box
        sx={(t) => ({
          width: 22,
          height: 22,
          flexShrink: 0,
          borderRadius: '50%',
          display: 'grid',
          placeItems: 'center',
          bgcolor: person.kind === 'ai' ? t.tokens.brand.primarySoft : t.tokens.surface.sunken,
          color: person.kind === 'ai' ? t.tokens.brand.primary : t.tokens.text.secondary,
        })}
      >
        <Typography variant="caption" sx={{ fontWeight: 600, lineHeight: 1 }}>
          {person.name.charAt(0)}
        </Typography>
      </Box>

      <Stack sx={{ minWidth: 0 }}>
        <Stack direction="row" alignItems="center" spacing={0.5} sx={{ minWidth: 0 }}>
          <Typography variant="body2" sx={(t) => ({ color: t.tokens.text.primary })} noWrap>
            {person.name}
          </Typography>
          {person.kind === 'ai' ? (
            <Box
              sx={(t) => ({
                px: 0.5,
                borderRadius: `${t.ds.radius.xs}px`,
                bgcolor: t.tokens.brand.primarySoft,
                color: t.tokens.brand.primary,
                flexShrink: 0,
              })}
            >
              <Typography variant="caption" sx={{ fontWeight: 600, lineHeight: 1.6 }}>AI</Typography>
            </Box>
          ) : null}
        </Stack>
        {subtitle ? (
          <Typography variant="caption" sx={(t) => ({ color: t.tokens.text.tertiary })} noWrap>
            {subtitle}
          </Typography>
        ) : null}
      </Stack>
    </Stack>
  );
}
